import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CreateResult } from '../../models/create-result';
import { TerminalTrackingViewModel } from '../../models/terminal-tracking-view-model';
import { TrackingInformationViewModel } from '../../models/tracking-information-view-model';
import { WaybillResponseViewModel } from '../../models/waybill-response-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';

@Component({
  selector: 'app-aramex-tracking',
  templateUrl: './aramex-tracking.component.html',
  styleUrls: ['./aramex-tracking.component.scss']
})


export class AramexTrackingComponent implements OnInit {

  public message: string;
  public success: boolean;
  public raiseDanger: boolean;
  public danger: string;
  public dtTrigger: Subject<boolean> = new Subject();
  public canManage: boolean;
  public WayBillFormGroup: FormGroup;
  public createResult: WaybillResponseViewModel;
  public terminalTracking: TerminalTrackingViewModel;
  public transactions: TrackingInformationViewModel[];
  public wayBill: string;
  private _destroyed$ = new Subject<any>();
  public canEditMerchantSignUp: boolean;

  constructor(
    private _httpClient: HttpClient,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _terminalService: TerminalService) {
    this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp]);
      if (!this.canManage) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      this.canEditMerchantSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantSignUp]);


      if (params.id != '' && params.id != undefined) {
        this.wayBill = params.id;
        this.submit();
      }

    });

    this.initObjects();
  }

  public async initObjects(): Promise<void> {

    this.WayBillFormGroup = this._formBuilder.group({
      wayBill: ['', Validators.compose([Validators.required, Validators.maxLength(23)])]
    });
  }

  ngOnInit(): void {

  }

  public async submit(): Promise<void> {

    

    if (this.wayBill == undefined || this.wayBill == "") {
      this.raiseDanger = true;
      this.danger = "Waybill is required!";
      this.success = false;
       return;
    }

    this._ngxUiLoaderService.start();

    this.createResult = await this._terminalService.TerminalsTracking(this.wayBill);
    if (this.createResult.status_code == 0) {
      this._toastService.success(this.createResult.status_description, "Success");
      this.raiseDanger = false;
      //display data here
      this.transactions = this.createResult.tracking_information;

    } else {
      this._toastService.error(this.createResult.status_description, "Error");
      this.raiseDanger = true;
      this.danger = this.createResult.status_description;
      this.message = this.createResult.status_description;
      this.success = false;
    }

    this._ngxUiLoaderService.stop();

  }


}
